import { getI18n } from 'react-i18next';

export const ERROR_CASH_LIMIT_UPLOAD_EVENT_INVALID_SORT_KEY = 'cashLimitUploadEvent.sort.invalidField';

export const createCashLimitUploadEventErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    if (code === ERROR_CASH_LIMIT_UPLOAD_EVENT_INVALID_SORT_KEY) {
        result = i18n.t('cash-limit-upload-events.error.cash-limit-upload-event-invalid-sort-key', { sortKey: params[0] });
    } else {
        result = undefined;
    }
    return result;
};
